import config from "@/config"
import { LabAllType } from "@/utils/globalConst"
import SharedDataContext from "@/utils/share"
import { Modal } from "antd"
import { useContext } from "react"

/**
 * 暴露一个全局用来处理资源错误的方法，返回true表明已经处理，如果返回false,表明没有进行任何处理
 */
export default function useResourcesLimit() {

    const { labCode, courseDetail, modal } = useContext(SharedDataContext)

    function handleResourseError(error: any, data?: { labCode: string, type: LabAllType, [key: string]: any }) {
        const { status, message, businessCode } = error
        if (businessCode === 10412) {
            let _labCode: string, labType
            if (data?.labCode && data?.type) {
                _labCode = data?.labCode
                labType = data?.type
            } else {
                _labCode = labCode
                labType = courseDetail?.labType
            }
            if (labType === 'EDUCATION' && modal !== '0') {
                Modal.confirm({
                    title: '温馨提示',
                    content: message,
                    okText: '升级版本',
                    centered: true,
                    width: 400,
                    cancelText: '我知道了',
                    onOk() {
                        const url = `${config.osApiURL}/membership?labCode=${_labCode}`
                        window.open(url)
                    }
                })
            } else {
                Modal.warning({
                    title: '温馨提示',
                    content: message,
                    okText: '我知道了',
                    centered: true,
                    width: 400
                })
            }
            return true
        }
        return false
    }

    return handleResourseError
}